import { render, staticRenderFns } from "./OEditStand.vue?vue&type=template&id=62ac4066&"
import script from "./OEditStand.vue?vue&type=script&lang=js&"
export * from "./OEditStand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports